import { REPORT_PRODUCT_ERROR_SUBJECT_TYPE } from 'b2b-common/shop/product/api/Product.types';

export enum FIELD_NAME {
  subject = 'subject',
  text = 'text',
  email = 'email',
}

export type FormValuesType = {
  [FIELD_NAME.subject]: REPORT_PRODUCT_ERROR_SUBJECT_TYPE,
  [FIELD_NAME.text]: string,
  [FIELD_NAME.email]: string,
}

export interface Props {
  onFormHide: () => void,
}
